import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ContractSignature } from '../../../models/contract/contract-signature';
import { ContractService } from '../../../services/contract/contract.service';

@Component({
    selector: 'app-legal-text-contract-bra-preb',
    templateUrl: './legal-text-contract-bra-preb.component.html',
    styleUrls: ['./legal-text-contract-bra-preb.component.scss'],
    standalone: false
})
export class LegalTextContractBraPrebComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  contractSignature: ContractSignature;
  contract?: number;
  document?: string;
  uuid?: string;

  constructor(
    private contractService: ContractService,
    private activatedRoute: ActivatedRoute,
  ) {

    this.contractSignature = new ContractSignature;
  }

  ngOnInit() {

    window.scrollTo(0, 0);

    this.activatedRoute.queryParams.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {

      this.uuid = params.uuid;
      if (this.uuid) {
        this.contractSummarySearch(this.uuid);
      }
    });
  }

  contractSummarySearch(uuid: string) {
    this.contractService
      .getContractSignature(uuid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ContractSignature) => {

        this.contractSignature = response;
      });
  }


}
